import React from 'react'

function WhatsappMaster() {
  return (
    <div>
      WhatsappMaster
    </div>
  )
}

export default WhatsappMaster
